export default __webpack_public_path__ + "static/media/challenge.853d161d.wav";